import React from 'react';
import { ArrowUpDown } from 'lucide-react';

/*
  One sortable header cell — replaces the near-identical
  `<th onClick={() => setSortConfig(...)}><ArrowUpDown/></th>` block that
  was hand-duplicated in every list screen's <thead>.
*/
const SortableTh = ({ label, sortKey, sortConfig, onSort, isRTL = false, className = '' }) => {
  const isActive = sortConfig?.key === sortKey;
  return (
    <th
      className={`p-3 border-r border-white/10 cursor-pointer hover:bg-black/10 transition-colors ${isRTL ? 'text-right' : ''} ${className}`}
      onClick={() => onSort(sortKey)}
    >
      <div className={`flex items-center justify-between gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
        {label}
        <ArrowUpDown size={12} className={isActive ? 'text-accent' : 'text-white/30'} />
      </div>
    </th>
  );
};

export default SortableTh;
